var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.732 2.194c-15.763 0-28.48 12.516-28.48 27.742 0 15.225 12.849 27.741 28.48 27.741 15.63 0 28.48-12.516 28.48-27.741 0-15.226-12.717-27.742-28.48-27.742zm0 57.806C13.776 60 0 46.58 0 29.936 0 13.29 13.776 0 30.732 0c16.955 0 30.731 13.42 30.731 29.936S47.82 60 30.732 60z",
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dkn60q322a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.104 40.177c0 1.157 1.229 1.736 3.685 1.736l-.83 4.916H19.024l.831-4.916c2.638 0 4.12-.687 4.373-2.097l1.734-10.195c0-1.229-1.192-1.807-3.613-1.807l.83-4.809h14.888l-2.963 17.172zm4.408-24.51c0 .759-.144 1.446-.433 2.096a6.33 6.33 0 0 1-1.157 1.736 5.036 5.036 0 0 1-1.734 1.157 5.18 5.18 0 0 1-2.096.433 5.18 5.18 0 0 1-2.096-.433 6.326 6.326 0 0 1-1.734-1.157 5.041 5.041 0 0 1-1.156-1.736 5.188 5.188 0 0 1-.434-2.096c0-.76.145-1.446.434-2.097.289-.65.686-1.23 1.156-1.735a5.038 5.038 0 0 1 1.734-1.157c.65-.253 1.337-.434 2.06-.434.723 0 1.445.145 2.096.434.65.289 1.228.687 1.734 1.157a5.04 5.04 0 0 1 1.156 1.735c.253.65.47 1.374.47 2.097z",
    fill: "#FFA489"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dkn60q322a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(19.024 10.244)",
    d: "M0 0h20.488v36.585H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramInfo);
export default __webpack_public_path__ + "static/media/program-info.e89e31712b0a640ca86ed579067895cc.svg";
export { ForwardRef as ReactComponent };